// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-input form .input-group {
  width: 105%; }
  .search-input form .input-group .icon-wrapper {
    border: none;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px; }
    .search-input form .input-group .icon-wrapper svg {
      color: #dcd7d7; }
  .search-input form .input-group input {
    background-color: #002754;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    color: #cfc9c9;
    border: none; }
    .search-input form .input-group input::placeholder {
      color: #dcd7d7; }
    .search-input form .input-group input:focus {
      box-shadow: unset; }
  .search-input form .input-group:focus-within {
    box-shadow: 0 0 0 0.25rem #01254fd4;
    border-radius: 3px; }
  .search-input form .input-group .icon-wrapper,
  .search-input form .input-group input {
    background-color: #01254f;
    color: #dcd7d7; }

.search-input .suggestions-list {
  margin-top: 1px;
  max-height: 400px;
  overflow-y: auto;
  position: absolute;
  z-index: 1000;
  width: 30%;
  min-width: 320px;
  padding: 0px;
  background-color: #002044c7;
  max-width: 500px; }
  .search-input .suggestions-list .list-group-item {
    background-color: #002044b5;
    color: white; }
    .search-input .suggestions-list .list-group-item:hover {
      background-color: #001833bc; }
  .search-input .suggestions-list .suggestion-list-subtitle {
    padding-left: 12px;
    background-color: #0b1736; }
  .search-input .suggestions-list .suggestion-list-item {
    padding-left: 32px; }

.search-input .search-form-input {
  padding-left: 0; }

.search-input .search-form-input::placeholder {
  font-size: 13px; }
`, "",{"version":3,"sources":["webpack://./src/layout/search-input.scss"],"names":[],"mappings":"AAAA;EAGQ,WAAW,EAAA;EAHnB;IAMU,YAAY;IACZ,2BAA2B;IAC3B,8BAA8B,EAAA;IARxC;MAUY,cAAc,EAAA;EAV1B;IAeU,yBAAyB;IACzB,4BAA4B;IAC5B,+BAA+B;IAC/B,cAAc;IACd,YAAY,EAAA;IAnBtB;MAsBY,cAAc,EAAA;IAtB1B;MA0BY,iBAAiB,EAAA;EA1B7B;IA+BU,mCAAmC;IACnC,kBAAkB,EAAA;EAhC5B;;IAqCY,yBAAyB;IACzB,cAAc,EAAA;;AAtC1B;EA4CM,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB,EAAA;EArDtB;IAwDQ,2BAA2B;IAC3B,YAAY,EAAA;IAzDpB;MA2DU,2BAA2B,EAAA;EA3DrC;IAgEQ,kBAAkB;IAClB,yBAAyB,EAAA;EAjEjC;IAqEQ,kBAAkB,EAAA;;AArE1B;EA2EM,eAAe,EAAA;;AA3ErB;EA+EM,eAAe,EAAA","sourcesContent":[".search-input {\r\n    form {\r\n      .input-group {\r\n        width: 105%;\r\n  \r\n        .icon-wrapper {\r\n          border: none;\r\n          border-top-left-radius: 3px;\r\n          border-bottom-left-radius: 3px;\r\n          svg {\r\n            color: #dcd7d7;\r\n          }\r\n        }\r\n  \r\n        input {\r\n          background-color: #002754;\r\n          border-top-right-radius: 3px;\r\n          border-bottom-right-radius: 3px;\r\n          color: #cfc9c9;\r\n          border: none;\r\n  \r\n          &::placeholder {\r\n            color: #dcd7d7;\r\n          }\r\n  \r\n          &:focus {\r\n            box-shadow: unset;\r\n          }\r\n        }\r\n  \r\n        &:focus-within {\r\n          box-shadow: 0 0 0 0.25rem #01254fd4;\r\n          border-radius: 3px;\r\n        }\r\n\r\n        .icon-wrapper,\r\n        input { \r\n            background-color: #01254f;\r\n            color: #dcd7d7;\r\n        }\r\n      }\r\n    }\r\n  \r\n    .suggestions-list {\r\n      margin-top: 1px;\r\n      max-height: 400px;\r\n      overflow-y: auto;\r\n      position: absolute;\r\n      z-index: 1000;\r\n      width: 30%;\r\n      min-width: 320px;\r\n      padding: 0px;\r\n      background-color: #002044c7;\r\n      max-width: 500px;\r\n  \r\n      .list-group-item {\r\n        background-color: #002044b5;\r\n        color: white;\r\n        &:hover {\r\n          background-color: #001833bc;\r\n        }\r\n      }\r\n\r\n      .suggestion-list-subtitle {\r\n        padding-left: 12px;\r\n        background-color: #0b1736;\r\n      }\r\n\r\n      .suggestion-list-item {\r\n        padding-left: 32px;\r\n      }\r\n\r\n    }\r\n\r\n    .search-form-input {\r\n      padding-left: 0;\r\n    }\r\n\r\n    .search-form-input::placeholder {\r\n      font-size: 13px;\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
